import { ICarpa, ICarpaLight, IUser } from '@core-lib/models';
import { createEntitySlice, IStoreEntityStateSlice } from '@core-lib/store';

export interface IUserStoreState {
	user: IStoreEntityStateSlice<IUser>;
	usersTenant: IStoreEntityStateSlice<IUser[]>;
	carpas: IStoreEntityStateSlice<ICarpaLight[]>;
	currentCarpa: IStoreEntityStateSlice<ICarpa>;
}

export const initialState: IUserStoreState = {
	user: createEntitySlice(),
	usersTenant: createEntitySlice(),
	carpas: createEntitySlice(),
	currentCarpa: createEntitySlice()
};
